/* eslint-disable */
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Grid,
  Heading,
  Input,
  Text,
  useToast,
  VStack,
  FormControl,
  FormHelperText,
  Spinner,
  useColorModeValue
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import AdminNavTop from "../AdminNavTop";
import { useSelector } from "react-redux";
import { capitalizeFirstLetter } from "../../Redux/UserReducer/action";
import axios from "axios";

const Setting = () => {
  const store = useSelector((store) => store.AdminReducer.data);
  const userStore = useSelector((store) => store.UserReducer);
  const name = capitalizeFirstLetter(userStore.name);
  const [passwordState, setPasswordState] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const [aiLimits, setAiLimits] = useState({ admin: 100, instructor: 20, employee: 5 });
  const [loadingLimits, setLoadingLimits] = useState(true);
  const [savingLimits, setSavingLimits] = useState(false);
  const toast = useToast();

  useEffect(() => {
    const fetchAiLimits = async () => {
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/settings/ai-limits`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAiLimits(res.data);
      } catch (err) {
        console.error("Failed to load AI token limits:", err);
        toast({
          title: "Error loading limits",
          description: err.response?.data?.message || "Failed to fetch settings.",
          status: "error",
          duration: 4000,
          isClosable: true,
          position: "top-right"
        });
      } finally {
        setLoadingLimits(false);
      }
    };
    fetchAiLimits();
  }, [toast]);

  const handleSaveAiLimits = async () => {
    setSavingLimits(true);
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      await axios.put(`${process.env.REACT_APP_API_URL}/api/settings/ai-limits`, aiLimits, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({
        title: "AI limits updated",
        description: "The daily AI request token limits have been successfully saved.",
        status: "success",
        duration: 4000,
        isClosable: true,
        position: "top-right"
      });
    } catch (err) {
      console.error("Failed to update AI token limits:", err);
      toast({
        title: "Update failed",
        description: err.response?.data?.message || "Failed to save settings.",
        status: "error",
        duration: 4000,
        isClosable: true,
        position: "top-right"
      });
    } finally {
      setSavingLimits(false);
    }
  };

  const handlePasswordChange = async () => {
    const { currentPassword, newPassword, confirmPassword } = passwordState;
    if (!currentPassword || !newPassword || !confirmPassword) {
      return toast({ title: "Please fill all fields", status: "warning", duration: 3000, position: "top-right" });
    }
    if (newPassword !== confirmPassword) {
      return toast({ title: "New passwords do not match", status: "error", duration: 3000, position: "top-right" });
    }
    setIsChangingPassword(true);
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/change-password`, {
        currentPassword,
        newPassword
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: "Password successfully updated!", status: "success", duration: 3000, position: "top-right" });
      setPasswordState({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      toast({ title: err.response?.data?.message || "Failed to update password", status: "error", duration: 4000, position: "top-right" });
    } finally {
      setIsChangingPassword(false);
    }
  };
  const boxBg = useColorModeValue("white", "gray.800");
  const glassBg = useColorModeValue("rgba(255, 255, 255, 0.7)", "rgba(0, 0, 0, 0.4)");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const purpleBorder = useColorModeValue("purple.100", "purple.900");
  const textColor = useColorModeValue("gray.700", "gray.100");
  const headingColor = useColorModeValue("purple.700", "purple.300");
  const inputBg = useColorModeValue("white", "gray.700");

  return (
    <Grid mx="auto" className="Nav" minH={"99vh"} w="94%" gap={10}>
      
      <Box mt='80px' mb={10}>
        <AdminNavTop />
        {/*  */}

        <Heading mb={6}>Settings</Heading>
        <Box mt={5}>
          {/* Profile Information Section */}
          <Flex
            justify={"space-between"}
            flexDirection={{ xl: "row", lg: "row", base: "column" }}
            p={5}
            gap={{ xl: 0, lg: 0, base: 10 }}
            mb={6}
          >
            <Box w={{ xl: "35%", lg: "35%", base: "100%" }}>
              <Heading size="md" mb={2} color={textColor}>Profile Information</Heading>
              <Text fontSize="sm" color="gray.500">Update User Profile Information and Password</Text>
            </Box>
            <Box border={"1px solid"} borderColor={borderColor} bg={boxBg} borderRadius={10} w={{ xl: "60%", lg: "60%", base: "100%" }} p={5}>
              <FormLabel>Name</FormLabel>
              <Input placeholder="Enter Name" defaultValue={name} />
              <Button 
                mt={5} 
                isDisabled={true}
                colorScheme="purple"
                borderRadius="xl"
              >
                Save
              </Button>
            </Box>
          </Flex>

          {/* Update Password Section */}
          <Flex
            justify={"space-between"}
            flexDirection={{ xl: "row", lg: "row", base: "column" }}
            p={5}
            gap={{ xl: 0, lg: 0, base: 10 }}
            mb={6}
          >
            <Box w={{ xl: "35%", lg: "35%", base: "100%" }}>
              <Heading size="md" mb={2} color={textColor}>Update Password</Heading>
              <Text fontSize="sm" color="gray.500">
                Ensure your account is using a long, random password to stay secure
              </Text>
            </Box>
            <Box border={"1px solid"} borderColor={borderColor} bg={boxBg} borderRadius={10} w={{ xl: "60%", lg: "60%", base: "100%" }} p={5}>
              <FormLabel>Current Password</FormLabel>
              <Input
                placeholder="Enter Current Password"
                type="password"
                value={passwordState.currentPassword}
                onChange={(e) => setPasswordState(prev => ({ ...prev, currentPassword: e.target.value }))}
                bg={inputBg}
              />
              <FormLabel mt={4}>New Password</FormLabel>
              <Input 
                placeholder="Enter New Password" 
                type="password"
                value={passwordState.newPassword}
                onChange={(e) => setPasswordState(prev => ({ ...prev, newPassword: e.target.value }))}
                bg={inputBg}
              />
              <FormLabel mt={4}>Confirm Password</FormLabel>
              <Input 
                placeholder="Enter Confirm Password" 
                type="password"
                value={passwordState.confirmPassword}
                onChange={(e) => setPasswordState(prev => ({ ...prev, confirmPassword: e.target.value }))}
                bg={inputBg}
              />
              <Button 
                mt={5} 
                colorScheme="purple"
                borderRadius="xl"
                bgGradient="linear(to-r, purple.500, blue.500)"
                color="white"
                _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)" }}
                onClick={handlePasswordChange}
                isLoading={isChangingPassword}
              >
                Update Password
              </Button>
            </Box>
          </Flex>

          {/* AI Copilot limits Section */}
          <Flex
            justify={"space-between"}
            flexDirection={{ xl: "row", lg: "row", base: "column" }}
            p={5}
            gap={{ xl: 0, lg: 0, base: 10 }}
            borderTop="1px dashed"
            borderColor="gray.200"
            pt={8}
            mt={4}
          >
            <Box w={{ xl: "35%", lg: "35%", base: "100%" }}>
              <Heading size="md" mb={2} color={headingColor} fontWeight="800">
                🤖 AI Copilot Limits
              </Heading>
              <Text fontSize="sm" color="gray.500" fontWeight="500">
                Configure the maximum number of daily requests (tokens) allowed per role for the Ask AI Course Copilot and Dashboard Advisor.
              </Text>
            </Box>
            <Box 
              border={"1px solid"} 
              borderColor={purpleBorder} 
              borderRadius={16} 
              w={{ xl: "60%", lg: "60%", base: "100%" }} 
              p={6} 
              bg={glassBg}
              backdropFilter="blur(10px)"
              boxShadow="sm"
            >
              {loadingLimits ? (
                <Flex justify="center" align="center" py={10}>
                  <Spinner color="purple.500" size="lg" />
                </Flex>
              ) : (
                <VStack spacing={5} align="stretch">
                  <FormControl>
                    <FormLabel fontWeight="700" fontSize="sm" color={textColor}>Admin Limit</FormLabel>
                    <Input 
                      type="number" 
                      placeholder="Requests per Day" 
                      value={aiLimits.admin} 
                      onChange={(e) => setAiLimits({ ...aiLimits, admin: parseInt(e.target.value) || 0 })}
                      focusBorderColor="purple.400"
                      borderRadius="xl"
                      bg={inputBg}
                    />
                    <FormHelperText fontSize="xs">Daily limit for administrators and super-admins.</FormHelperText>
                  </FormControl>

                  <FormControl>
                    <FormLabel fontWeight="700" fontSize="sm" color={textColor}>Instructor Limit</FormLabel>
                    <Input 
                      type="number" 
                      placeholder="Requests per Day" 
                      value={aiLimits.instructor} 
                      onChange={(e) => setAiLimits({ ...aiLimits, instructor: parseInt(e.target.value) || 0 })}
                      focusBorderColor="purple.400"
                      borderRadius="xl"
                      bg={inputBg}
                    />
                    <FormHelperText fontSize="xs">Daily limit for teachers and instructors.</FormHelperText>
                  </FormControl>

                  <FormControl>
                    <FormLabel fontWeight="700" fontSize="sm" color={textColor}>Employee Limit</FormLabel>
                    <Input 
                      type="number" 
                      placeholder="Requests per Day" 
                      value={aiLimits.employee} 
                      onChange={(e) => setAiLimits({ ...aiLimits, employee: parseInt(e.target.value) || 0 })}
                      focusBorderColor="purple.400"
                      borderRadius="xl"
                      bg={inputBg}
                    />
                    <FormHelperText fontSize="xs">Daily limit for standard corporate employees/students.</FormHelperText>
                  </FormControl>

                  <Button 
                    bgGradient="linear(to-r, purple.500, blue.500)" 
                    color="white" 
                    borderRadius="xl"
                    _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)" }}
                    boxShadow="sm"
                    onClick={handleSaveAiLimits}
                    isLoading={savingLimits}
                    fontWeight="800"
                    alignSelf="flex-start"
                    px={6}
                    mt={2}
                  >
                    Save AI Limits
                  </Button>
                </VStack>
              )}
            </Box>
          </Flex>
        </Box>
      </Box>
    </Grid>
  );
};

export default Setting;
